import { useMutation, useQueryClient } from '@tanstack/react-query'

import useAuth from 'hooks/useAuth'
import { queryErrorToast, querySuccessToast } from 'queries/query-toasts'
import axiosServices from 'utils/axios'

function unarchiveSubsidiary({ business_id, id }: { business_id: number; id: number }) {
  return axiosServices.post(`/businesses/${business_id}/subsidiaries/${id}/unarchive`)
}

export const useUnarchiveSubsidiary = () => {
  const { user } = useAuth()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ id }: { id: number }) =>
      unarchiveSubsidiary({ business_id: user?.business_id!, id }),
    onSuccess: () => {
      querySuccessToast('Subsidiary Unarchived Successfully')
      queryClient.invalidateQueries({
        queryKey: ['fetch-subsidiaries-hierarchy', user?.business_id]
      })
      queryClient.invalidateQueries({
        queryKey: ['fetch-model-properties']
      })
    },
    onError: (err, variables) => {
      queryErrorToast(`Error Unarchiving Subsidiary. \n ${err?.message}`)
    }
  })
}
